/* src/app/modules/shared/components/header-column/header-column-asset/header-column-asset.component.scss */
app-header-column-asset {
  display: contents;
}
/*# sourceMappingURL=header-column-asset.component.css.map */
